const Tag = ({ tag, tagsSetting }) => {
  let color
  let label

  tagsSetting.forEach(tagSetting => {
    if (tagSetting.value === tag) {
      color = tagSetting.color
      label = tagSetting.label
    }
  })
  return (
    <div
      className='tag-container'
      style={{ backgroundColor: color }}
      key={tag}
    >
      <p className='tag-value'>
        {label}
      </p>
    </div>
  )
}

export default Tag
